import React, { useState, useEffect } from 'react';
import NonMemberSignupLeftSection from './NonMemberSignupLeftSection';
import NonMemberSignupFormPreview from './NonMemberSignupFormPreview';
import {
  Container,
  LeftSection,
  RightSection,
  SubscribersDashboardWrapper,
} from './NonMemberSignup.styled';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectedOrganizationSelector,
  userDetailSelector,
} from '../../../../redux/selector';
import SubscribersDashboard from './SubscribersDashboard';
import { toast } from '../../../../redux/actions/UI';
import {
  getNonMemberFormHeader,
  saveNonMemberFormHeader,
} from '../../../../redux/services/nonmemberSignUp';
import { getLogoUrl } from '../../../../redux/services';

const NonmemberSignupPage = ({ goToPreferencePage }) => {
  const selectedOrg = useSelector(selectedOrganizationSelector);
  const userDetail = useSelector(userDetailSelector);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const [headerText, setHeaderText] = useState('');
  const [logoUrl, setLogoUrl] = useState('');

  const onTextChange = text => {
    if (!loading) {
      if (text != headerText) {
        setIsEdited(true);
      }
      setHeaderText(text);
    }
  };

  const getLogo = async id => {
    if (id) {
      const logoUrl = await getLogoUrl(id);
      setLogoUrl(logoUrl);
    }
  };

  const getHeader = async () => {
    let response = await getNonMemberFormHeader(selectedOrg.id);
    if (response && response.content) {
      setHeaderText(response.content);
    } else {
      setHeaderText('');
      console.error('Error fetching NonMemberFormHeader:', response?.error);
    }
  };

  const onHeaderSave = async () => {
    setLoading(true);
    try {
      let response = await saveNonMemberFormHeader({
        orgId: selectedOrg.id,
        content: headerText,
        userId: userDetail.id,
      });
      if (response && response.content) {
        await getHeader();
        setIsEdited(false);
        dispatch(toast('success', 'Header text saved successfully'));
      } else {
        dispatch(toast('error', 'Error saving header text'));
      }
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
      dispatch(toast('error', 'Error saving header text'));
    }
  };

  useEffect(() => {
    if (selectedOrg.id) {
      getHeader();
      getLogo(selectedOrg.id);
    }
  }, [selectedOrg.id]);

  return (
    <Container>
      <LeftSection>
        <NonMemberSignupLeftSection
          selectedOrg={selectedOrg}
          goToPreferencePage={goToPreferencePage}
          onTextChange={onTextChange}
          loading={loading}
          isEdited={isEdited}
          headerText={headerText}
          onHeaderSave={onHeaderSave}
        />
        <SubscribersDashboardWrapper>
          <SubscribersDashboard selectedOrg={selectedOrg} />
        </SubscribersDashboardWrapper>
      </LeftSection>
      <RightSection>
        <NonMemberSignupFormPreview
          headerText={headerText}
          logoUrl={logoUrl}
          organizationName={selectedOrg.organizationName}
        />
      </RightSection>
    </Container>
  );
};

export default NonmemberSignupPage;
